import { useState } from 'react';
import { signInWithPopup, signOut } from 'firebase/auth';
import { firebaseAuth, googleProvider } from '../../lib/firebase';
import { getAllowedEmailDomains, isAllowedEmail } from '../../lib/authDomain';
import { Button } from '../../components/ui/button';

export function SignIn({ initialError }: { initialError?: string }) {
  const [error, setError] = useState<string | null>(initialError ?? null);
  const [busy, setBusy] = useState(false);

  const handleSignIn = async () => {
    setError(null);
    setBusy(true);
    try {
      const result = await signInWithPopup(firebaseAuth, googleProvider);
      const email = result.user.email;
      if (!isAllowedEmail(email)) {
        await signOut(firebaseAuth);
        const allowed = getAllowedEmailDomains().join(', ');
        setError(`Sign-in is restricted to ${allowed} accounts.`);
      }
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Sign-in failed.';
      setError(message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="bg-white p-8 rounded-lg shadow-sm border border-slate-200 max-w-sm w-full text-center">
        <h1 className="text-2xl font-semibold mb-2 text-slate-900">Kyck</h1>
        <p className="text-slate-600 text-sm mb-6">Sign in with your Kyck Google account.</p>
        <Button onClick={handleSignIn} disabled={busy} className="w-full">
          {busy ? 'Signing in…' : 'Sign in with Google'}
        </Button>
        {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      </div>
    </div>
  );
}
